import type { RouteRecordRaw, Router } from 'vue-router'

const RegistrationRoutes: RouteRecordRaw = {
  path: '/registration/notice',
  name: 'RegistrationModulePages',
  children: [
    {
      path: '',
      name: 'NoticeView',
      component: () => import('./views/NoticeView.vue'),
      meta: {
        title: 'notice.judicialNotice',
      },
    },
    {
      path: 'create',
      name: 'CreateNoticeView',
      component: () => import('./views/NoticeUpsertView.vue'),
      meta: {
        title: 'notice.createNotice',
        pageHasBack: true,
      },
    },
    {
      path: 'edit/:noticeId',
      name: 'EditNoticeView',
      component: () => import('./views/NoticeUpsertView.vue'),
      meta: {
        title: 'notice.editNotice',
        pageHasBack: true,
      },
    },
    {
      path: 'view/:noticeId',
      name: 'SingleNoticeView',
      component: () => import('./views/SingleNoticeView.vue'),
      meta: {
        title: 'notice.viewNotice',
        pageHasBack: true,
      },
    },
  ],
  meta: {
    layout: 'Default',
  },
}

export default (router: Router) => {
  router.addRoute(RegistrationRoutes)
}
